import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const LearnMoreLayout = () => {
  return (
    <FDStack direction="column" paddingY={1} spacing={8} flex={1}>
      <FDStack direction="column" spacing={3}>
        <MetaControlField attr="title" />
        <MetaControlField attr="subtitle" />
        <MetaControlField attr="articles" />
      </FDStack>
      <MetaControlField attr="frequentlyAskedQuestions" />
    </FDStack>
  );
};
